export const MIN_PASSWORD_LENGTH = 8
export const MAX_PASSWORD_LENGTH = 20
